import React from 'react'
import Createdepartmentworkrequest from '../../components/departmentworkrequsetcomponents/Createdepartmentworkrequest'

function DepartmentworkrequestRegister({renderPageContent}) {
    return (
        <>
                        <Createdepartmentworkrequest renderPageContent={renderPageContent}/>
        </>
    )
}

export default DepartmentworkrequestRegister
